'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _googleMapsReact = require('google-maps-react');

var _googleMapsReact2 = _interopRequireDefault(_googleMapsReact);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _InfoWindowContent = require('../InfoWindowContent');

var _InfoWindowContent2 = _interopRequireDefault(_InfoWindowContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY = 'AIzaSyCVdMVkJH49iCg3M3eUpG3hztCcOc1TWoY';

var MapComponent = function (_Component) {
    _inherits(MapComponent, _Component);

    function MapComponent(props) {
        _classCallCheck(this, MapComponent);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _initialiseProps.call(_this);

        _this.state = {
            activeMarker: props.activeMarker,
            defaultPosition: { lat: 40.316084, lng: -96.067057 },
            mapHeight: _this._getMapHeight()
        };
        return _this;
    }

    MapComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var activeMarkerExists = !_lodash2.default.isEmpty(nextProps.activeMarker);
        if (!activeMarkerExists && nextProps.selectedLocation) {
            if (this.markerNodes[nextProps.selectedLocation.id]) {
                this.setState({
                    activeMarker: this.markerNodes[nextProps.selectedLocation.id].marker
                });
            }
        } else if (activeMarkerExists && nextProps.activeMarker !== this.state.activeMarker) {
            this.setState({
                activeMarker: nextProps.activeMarker
            });
        }
    };

    MapComponent.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('resize', this._updateMapHeight);
    };

    MapComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('resize', this._updateMapHeight);
    };

    MapComponent.prototype.render = function render() {
        var containerStyle = {
            width: '100%',
            height: this.state.mapHeight,
            position: 'relative',
            overflow: 'hidden'
        };

        return _react2.default.createElement(
            _googleMapsReact2.default,
            { google: this.props.google,
                onReady: this.onMapReady,
                zoom: this.props.zoom,
                panControl: false,
                initialCenter: this.state.defaultPosition,
                scrollwheel: false,
                onClick: this.onMapClicked,
                containerStyle: containerStyle,
                center: this.getCenterPosition()
            },
            this.getMarkers(),
            _react2.default.createElement(
                _googleMapsReact.InfoWindow,
                {
                    marker: this.state.activeMarker,
                    visible: this.props.showInfo,
                    onClose: this.closeInfoWindow },
                _react2.default.createElement(_InfoWindowContent2.default, { mapLoaded: !!this.state.mapLoaded, selectedLocation: this.props.selectedLocation })
            )
        );
    };

    return MapComponent;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onMapReady = function (props, map) {
        _this2.setState({
            mapLoaded: true,
            mapProps: props,
            map: map });
    };

    this.getMarkers = function () {
        _this2.markerNodes = {};

        var locations = _this2.props.locations;
        if (!(locations && locations.length)) {
            return [];
        }

        return locations.map(function (location) {
            var locationId = location.id;
            return _react2.default.createElement(_googleMapsReact.Marker, {
                key: location.id,
                ref: function ref(markerNode) {
                    _this2.markerNodes[locationId] = markerNode;
                },
                onClick: _this2.onMarkerClick,
                name: location.address1,
                position: { lat: location.location.lat, lng: location.location.lon },
                location: location,
                icon: {
                    url: _this2.props.getPinUrl(location, _this2.props.selectedLocation),
                    scaledSize: new google.maps.Size(27, 37),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(14, 37)
                }
            });
        });
    };

    this.getCenterPosition = function () {
        var locations = _this2.props.locations;
        return locations.length ? { lat: parseFloat(locations[0].location.lat), lng: parseFloat(locations[0].location.lon) } : _this2.state.defaultPosition;
    };

    this.closeInfoWindow = function () {
        _this2.props.setParentState({
            showInfo: false
        });
    };

    this.onMapClicked = function () {
        if (_this2.props.showInfo) {
            _this2.closeInfoWindow();
        }
    };

    this.onMarkerClick = function (props, marker, e) {
        _this2.props.setParentState({
            selectedLocation: props.location,
            showInfo: true,
            activeMarker: marker
        });
    };

    this._updateMapHeight = function () {
        if (window.innerWidth <= 768 && _this2.state.mapHeight !== '310px') {
            _this2.setState({ mapHeight: '310px' });
        } else if (window.innerWidth > 768 && _this2.state.mapHeight !== '475px') {
            _this2.setState({ mapHeight: '475px' });
        }
    };

    this._getMapHeight = function () {
        return window.innerWidth <= 768 ? '310px' : '475px';
    };
};

MapComponent.propTypes = {
    google: _propTypes2.default.object,
    showInfo: _propTypes2.default.bool.isRequired,
    activeMarker: _propTypes2.default.object.isRequired,
    selectedLocation: _propTypes2.default.object,
    locations: _propTypes2.default.arrayOf(_propTypes2.default.object),
    getPinUrl: _propTypes2.default.func.isRequired,
    setParentState: _propTypes2.default.func.isRequired,
    zoom: _propTypes2.default.number.isRequired
};

exports.default = (0, _googleMapsReact.GoogleApiWrapper)({
    apiKey: KEY
})(MapComponent);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/Map/index.js
// module id = 804
// module chunks = 0